module.exports = __webpack_public_path__ + "static/media/Lexus.bf54a12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lexus.png
// module id = 364
// module chunks = 0